/** Four equally weighted sections, matching UsersTable.calculateProfileCompletion. */
export const calculateProfileCompletion = (user) => {
  if (!user) return null;

  const sections = [
    Boolean(user.professional_title && user.avatar),
    Array.isArray(user.experiences) && user.experiences.length > 0,
    Array.isArray(user.educations) && user.educations.length > 0,
    Array.isArray(user.expertise) && user.expertise.length > 0,
  ];

  return sections.filter(Boolean).length * 25;
};
